var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBatchNotRegistered(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0972 2.3125C16.1667 2.38194 16.2014 2.46528 16.2014 2.5625C16.2014 2.65972 16.1667 2.74306 16.0972 2.8125L15.3333 3.5764L14.1528 2.39583L14.9444 1.60417C15.0139 1.53472 15.088 1.5 15.1667 1.5C15.2454 1.5 15.3195 1.53472 15.3889 1.60417L16.0972 2.3125ZM7.65 10.2292C7.56716 10.2292 7.5 10.162 7.5 10.0792V9.11076C7.5 9.07097 7.5158 9.03282 7.54393 9.00469L13.625 2.92362L14.8055 4.10417L8.72448 10.1852C8.69635 10.2134 8.65819 10.2292 8.61841 10.2292H7.65Z",
    fill: "black",
    fillOpacity: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8536 4C16.6879 4 16.5536 4.13431 16.5536 4.3V15.1214H1.44643V3.87136H10.7C10.8657 3.87136 11 3.73704 11 3.57136V2.72493C11 2.55924 10.8657 2.42493 10.7 2.42493H0.642857C0.287277 2.42493 0 2.7122 0 3.06778V15.9249C0 16.2805 0.287277 16.5678 0.642857 16.5678H17.3571C17.7127 16.5678 18 16.2805 18 15.9249V4.3C18 4.13431 17.8657 4 17.7 4H16.8536Z",
    fill: "black",
    fillOpacity: 0.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.47478 10.2731H5.95379C5.97991 10.2731 6 10.2008 6 10.1124V9.14814C6 9.05975 5.97991 8.98743 5.95379 8.98743H3.47478C3.44866 8.98743 3.42857 9.05975 3.42857 9.14814V10.1124C3.42857 10.2008 3.44866 10.2731 3.47478 10.2731Z",
    fill: "black",
    fillOpacity: 0.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.57121 13.166H12.8018C12.8801 13.166 12.9444 13.0937 12.9444 13.0053V12.041C12.9444 11.9526 12.8801 11.8803 12.8018 11.8803H3.57121C3.49286 11.8803 3.42857 11.9526 3.42857 12.041V13.0053C3.42857 13.0937 3.49286 13.166 3.57121 13.166Z",
    fill: "black",
    fillOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatchNotRegistered);
export default __webpack_public_path__ + "static/media/BatchNotRegistered.090efcc070cd4126f7265b6ba7c4f920.svg";
export { ForwardRef as ReactComponent };